import { GROUPS_OPEN_CHAT_IDS_SESSIONSTORAGE } from '../helpers/setGroupOpenedChatId';

export const getGroupOpenedChatIds = () => {
    const data = sessionStorage.getItem(GROUPS_OPEN_CHAT_IDS_SESSIONSTORAGE);
    return data ? JSON.parse(data) : {};
}
